<template>
  <md-datepicker class="custom-date-picker" v-model="inputValue" ref="dp" :md-immediately="true">
    <slot></slot>
    <button
      v-show="inputValue"
      @click="clearDateFrom"
      type="button"
      class="md-clear-button-hack md-button md-icon-button md-dense md-input-action md-theme-default"
      tabindex="-1">
      <div class="md-ripple">
        <div class="md-button-content">
          <i class="md-icon md-icon-font md-icon-image md-theme-default">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path> <path d="M0 0h24v24H0z" fill="none"></path></svg>
          </i>
        </div>
      </div>
    </button>
  </md-datepicker>
</template>

<script>
// This is a wrapper for md-datepick, which for some reason cannot clear date fields
export default {
  name: 'Datepicker',
  props: ['value'],
  data () {
    return {
      inputValue: this.value
    }
  },
  watch: {
    inputValue (value) {
      this.$emit('input', value)
    },
    value (newValue) {
      this.inputValue = this.value
    }
  },
  methods: {
    clearDateFrom () {
      this.inputValue = null
      this.$refs.dp.selectedDate = null
      this.$refs.dp.modelDate = this.$refs.dp.dateToHTMLString(null)
    }
  }

}
</script>

<style lang="scss">
.custom-date-picker {
  .md-clear {
    display: none !important;
  }

  .md-datepicker .md-clear-button-hack {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Datepicker.vue